module.exports = __webpack_public_path__ + "img/null.715c8973.png";